export default __webpack_public_path__ + "static/media/reddit.177c9f9b.svg";